<script>
export default {
  name: "imageText",
  data(){
    return{
      id:'a1',
    }
  },
  watch:{
    '$route.params':{
      deep:true,
      immediate:true,
      handler(n){
        console.log(n)
        this.id = n.id
      }
    }
  }
}
</script>

<template>
<div>
  <ul class="appleUl" v-show="id==='a1'">
    <li id="appleLi"><img class="appleImg" src="@/assets/appleImg/apple1.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleImg/apple2.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleImg/apple3.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleImg/apple4.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleImg/apple5.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleImg/apple6.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleImg/apple7.jpg" alt=""></li>
  </ul>
  <ul class="appleUl" v-show="id==='a2'">
    <li id="appleLi"><img class="appleImg" src="@/assets/appleConfigImg/apple2.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleConfigImg/apple3.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleConfigImg/apple4.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleConfigImg/apple5.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleConfigImg/apple6.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleConfigImg/apple7.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleConfigImg/apple8.jpg" alt=""></li>
    <li id="appleLi"><img class="appleImg" src="@/assets/appleConfigImg/apple1.jpg" alt=""></li>
  </ul>
</div>
</template>

<style scoped lang="scss">
.appleUl{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  #appleLi{
    margin-top: 20px;
    margin-left: 50px;
  }
}
.appleImg{
  width: 250px;
  height: 450px;
}
</style>